import * as Joi from 'joi';
import { getJoiObject } from '../../../../../utils/JoiUtils';

export interface AddAdmissionLevelData {
  admissionLevel: string;
  dateOfBirthFrom: string;
  dateOfBirthTo: string;
  examVacancy: string;
}

const EXAM_VACANCY_ERROR = 'Exam Vacancy must be a number below or equal to 9999.';

const AddAdmissionLevel = () =>
  Joi.object<AddAdmissionLevelData>({
    admissionLevel: getJoiObject(
      Joi.string().required().messages({
        'any.required': 'Admission Level is not allowed to be empty.',
        'string.base': 'Admission Level is not allowed to be empty.',
      })
    ),
    dateOfBirthFrom: Joi.date().required().messages({
      'any.required': 'Date of Birth From is not allowed to be empty.'
    }),
    dateOfBirthTo: Joi.date().required().greater(Joi.ref('dateOfBirthFrom')).messages({
      'date.greater': 'Date of Birth To must be greater than Date of Birth From.',
      'any.required': 'Date of Birth To is not allowed to be empty.'
    }),
    examVacancy: getJoiObject(
      Joi.number().required().min(0).max(9999).messages({
        'number.base': 'Exam Vacancy is not allowed to be empty',
        'number.min': EXAM_VACANCY_ERROR,
        'number.max': EXAM_VACANCY_ERROR,
      })
    ),
  });
export default AddAdmissionLevel;
